export interface IAnimationDetailGridProps {
  children: JSX.Element[];
}
